import React from 'react';
import Revew from './Revew.js';
const RevewSetup = () => {

    return (
        <main>
      <section className='container'>
        <div className='title'>
          <h2>our reviews</h2>
          <div className='underline'></div>
        </div>
        <Revew />
      </section>
    </main>
    );
};

export default RevewSetup;